import React from "react";
import { styled } from "@linaria/react";
import { color } from "..";
import Link from "../Link";
import { fonts } from "../Theme";

const SECTION_GAP_PX = 16;

const Title = styled.div`
  color: ${color.carbon900};
  font: ${fonts.h3};
  white-space: nowrap;
`;

const ActionButton = styled(Link)`
  display: flex;
  align-items: center;
  color: ${color.titanium600};
  font: ${fonts.body1};
  svg {
    height: 30px;
    padding: 5px;
    margin-right: 5px;
  }
  :hover {
    transition: all 0.3s ease-in-out;
    color: ${color.carbon800};
    cursor: pointer;
  }
  &.disabled {
    opacity: 0.4;
    :hover {
      color: ${color.titanium600};
      cursor: not-allowed;
    }
  }
`;

const Actions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${/* sc-selector */ ActionButton}:not(:last-child) {
    margin-right: 16px;
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${SECTION_GAP_PX}px;
`;

interface P<SectionId extends string> {
  title: string | React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
  id: SectionId;
  className?: string;
}

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${SECTION_GAP_PX * 3}px;
`;

function Section<SectionId extends string>({
  title,
  actions,
  children,
  id,
  className,
}: P<SectionId>) {
  return (
    <Wrapper id={id} className={className}>
      {(title || actions) && (
        <Header>
          <Title>{title}</Title>
          {actions && <Actions>{actions}</Actions>}
        </Header>
      )}
      {children}
    </Wrapper>
  );
}

export { ActionButton };
export default React.memo(Section) as typeof Section;
